import { ReactNode, useState } from 'react';
import styles from './DailyCheck.module.css';
import Goal from "src/models/Goal";


interface DailyCheckProps {
  ontoggle: Function,
  goal: Goal,
  isChecked: boolean,
  children?: ReactNode
}

const DailyCheck: React.FC<DailyCheckProps> = ({ ontoggle, goal, isChecked }) => {
  const [isHovered, setIsHovered] = useState<boolean>(false);

  const toggleCheckbox = () => {
    ontoggle(goal);
  }
  const handleOnMouseEnter = () => {
    setIsHovered(true);
  }
  const handleOnMouseLeave = () => {
    setIsHovered(false);
  }

  const checkboxStyles = {
    // backgroundColor: isChecked ? `rgba(${selectedColor.r},${selectedColor.g},${selectedColor.b},${selectedColor.a})` : 'transparent', // Change color when checked
    backgroundColor: isChecked ? 'green' : 'transparent', // Change color when checked
    
  };
  const hoverdetectStyles = {
    transform: isHovered ? `scale(1.1)` : `scale(1.0)`,
  }
  // Define component
  //squarediv is the background. (show a colour based on the game category(STR,INT))
  //need to put in a border image
  //contentImage is the goal main image.
  return (

      <div 
      onMouseEnter={handleOnMouseEnter}
        onMouseLeave={handleOnMouseLeave}
        className={styles.hoverDetectDiv}
        style={hoverdetectStyles}>
        <div className={styles.squareDiv}
        style={checkboxStyles}
          onClick={toggleCheckbox}
          >
          <div className={styles.text}>{goal.title.toUpperCase()}</div>
          <img className={styles.dailyContentImage} src={`logo192.png` ?? `logo192.png`} style={hoverdetectStyles} />
          <img className={styles.dailyBorderImage} src={`dailies-border.png`} />

        </div>
      </div> 


  );
};

export default DailyCheck;
